import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { CustomSnackBarComponent } from 'app/common/custom-snack-bar/custom-snack-bar.component';
import { environment } from '@environment/environment';
import { UrlService } from '@service/url/url.service';
import { RestService } from 'cargo-chief-commons';
import { firstValueFrom } from 'rxjs';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AddCarriersDialogComponent } from '@shared/add-carriers-dialog/add-carriers-dialog.component';

@Injectable({
	providedIn: 'root',
})
export class ProjectUtilService {
	constructor(
		private matSnackbar: MatSnackBar,
		private urlService: UrlService,
		private restService: RestService,
		private dialog: MatDialog
	) {}

	isProjectExistsError(error) {
		const errorMessage = error['errorMessage'];
		return (
			errorMessage && errorMessage.includes('Project already exists') && error['existingProjectId']
		);
	}

	showProjectExistsError({ forAdd, error }: { forAdd: boolean; error: Object }) {
		const existingProjectId = error['existingProjectId'];
		const displayMessage = `Cannot ${forAdd ? 'add' : 'update'} project as project already
            <a href='${environment.clientUrl}projects/project_details/${existingProjectId}' class='color-white text-underline'>exists</a>`;
		this.matSnackbar.openFromComponent(CustomSnackBarComponent, {
			verticalPosition: 'top',
			panelClass: SNACKBAR.ERROR,
			duration: SNACKBAR.CUSTOM_SNACKBAR_DURATION,
			data: {
				html: displayMessage,
			},
		});
	}

	getEquipmentForScorecardLane({
		originCity,
		originState,
		destinationCity,
		destinationState,
		scorecardStartDate,
		scorecardEndDate,
		scorecardLoadsCount,
		carrierId,
		customerId,
	}: {
		originCity?: string;
		originState?: string;
		destinationCity?: string;
		destinationState?: string;
		scorecardStartDate: string;
		scorecardEndDate: string;
		scorecardLoadsCount: number;
		carrierId?: string;
		customerId?: string;
	}): Promise<{ data: string }> {
		const payload = {
			originCity,
			originState,
			destinationCity,
			destinationState,
			scorecardStartDate,
			scorecardEndDate,
			scorecardLoadsCount,
			carrierId,
			customerId,
		};
		const url = this.urlService.getProjectEquipment();
		return firstValueFrom(this.restService.POST(url, payload));
	}

	showAddCarriersDialog({
		startDate,
		endDate,
		originCity,
		originState,
		destinationCity,
		destinationState,
		loadsCount,
		customerId,
		projectIdList,
	}): Promise<any> {
		const dialogRef = this.dialog.open(AddCarriersDialogComponent, {
			width: '600px',
			data: {
				scorecardStartDate: startDate,
				scorecardEndDate: endDate,
				originCity: originCity,
				originState: originState,
				destinationCity: destinationCity,
				destinationState: destinationState,
				scorecardLoadsCount: loadsCount,
				customerId: customerId,
				projectIdList: projectIdList,
				title: 'Add Carriers To Project',
			},
		});
		return dialogRef.afterClosed().toPromise();
	}
}
